import { Box, Inline, Text } from 'braid-design-system';
import React from 'react';

interface KeywordsProps {
  keywords: string;
}

export const Keywords = ({ keywords }: KeywordsProps) => (
  <Inline space="xsmall">
    <Text weight="strong">Keywords:</Text>
    <Box data-testid="profile-saved-searches-keywords-display-text">
      <Text>{keywords}</Text>
    </Box>
  </Inline>
);
